/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AppQueryVariables = {};
export type AppQueryResponse = {
    readonly umbraco: {
        readonly content: {
            readonly byType: {
                readonly " $fragmentRefs": FragmentRefs<"SpeakersPageQuery" | "PartnersPageQuery" | "Home_query_speakers" | "Home_query_partners" | "SpeakerPageQuery" | "AgendaPageQuery">;
            };
            readonly getAllDictionary: ReadonlyArray<{
                readonly key: string | null;
                readonly value: string | null;
            }> | null;
            readonly atRoot: {
                readonly errorPage: {
                    readonly " $fragmentRefs": FragmentRefs<"NotFound">;
                } | null;
                readonly home: {
                    readonly items: ReadonlyArray<{
                        readonly themes: ReadonlyArray<{
                            readonly title?: string;
                            readonly technologies?: ReadonlyArray<string | null>;
                        } | null>;
                        readonly speaker: ReadonlyArray<{
                            readonly _id?: string;
                            readonly _name?: string | null;
                            readonly _url?: string | null;
                            readonly speakerName?: string;
                            readonly speakerPreviewDescription?: string | null;
                            readonly speakerImage?: string;
                            readonly facebookLink?: string | null;
                            readonly twitterLink?: string | null;
                            readonly linkedinLink?: string | null;
                            readonly location?: {
                                readonly city?: string;
                                readonly countryName?: string;
                                readonly country?: {
                                    readonly _url?: string | null;
                                };
                            };
                        } | null> | null;
                        readonly " $fragmentRefs": FragmentRefs<"Home_query" | "FaqQuery" | "AboutQuery" | "PolicyQuery" | "CodeOfConductQuery" | "BecomePartnerQuery" | "RegisterForEventQuery" | "BecomeSpeakerQuery" | "SpeakerContractQuery" | "ReportAccidentQuery">;
                    } | null> | null;
                } | null;
            };
        };
    };
};
export type AppQuery = {
    readonly response: AppQueryResponse;
    readonly variables: AppQueryVariables;
};



/*
query AppQuery {
  umbraco {
    content {
      byType {
        ...SpeakersPageQuery
        ...PartnersPageQuery
        ...Home_query_speakers
        ...Home_query_partners
        ...SpeakerPageQuery
        ...AgendaPageQuery
      }
      getAllDictionary {
        key
        value
      }
      atRoot {
        errorPage {
          ...NotFound
        }
        home {
          items {
            ...Home_query
            ...FaqQuery
            ...AboutQuery
            ...PolicyQuery
            ...CodeOfConductQuery
            ...BecomePartnerQuery
            ...RegisterForEventQuery
            ...BecomeSpeakerQuery
            ...SpeakerContractQuery
            ...ReportAccidentQuery
            themes {
              __typename
              ... on ThemesPublishedContent {
                title
                technologies
              }
            }
            speaker {
              __typename
              ... on SpeakerPublishedContent {
                _id
                _name
                _url
                speakerName
                speakerPreviewDescription
                speakerImage
                facebookLink
                twitterLink
                linkedinLink
                location {
                  __typename
                  ... on LocationPublishedContent {
                    city
                    countryName
                    country {
                      __typename
                      ... on FilePublishedMedia {
                        _url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

fragment AboutQuery on HomePublishedContent {
  _children {
    items {
      __typename
      ... on AboutPublishedContent {
        brandPacks {
          __typename
          ... on BrandPackPublishedContent {
            brandTitle
            darkMode
            logoPreview {
              __typename
              _url
              _name
            }
            sVGResource {
              __typename
              _name
              _url
            }
            pNGResource {
              __typename
              _name
              _url
            }
            ePSResource {
              __typename
              _name
              _url
            }
          }
        }
        metaTitle
        headerTilte
        headerText
        photoCarousel {
          __typename
          ... on CarouselItemPicturePublishedContent {
            picture
            fullImage
          }
        }
        infoItems {
          __typename
          ... on InfoItemPublishedContent {
            text
            value
          }
        }
        contentText
        contentTitle
        conferenceFiles {
          __typename
          _id
          _name
          _url
          ... on FilePublishedMedia {
            umbracoBytes
            _updateDate
          }
        }
      }
    }
  }
}

fragment AgendaPageQuery on PublishedContentByTypeQuery {
  agenda {
    items {
      programCommitee {
        __typename
        ... on SpeakerPublishedContent {
          _id
          _url
          speakerName
          speakerImage
          speakerPreviewDescription
          facebookLink
          linkedinLink
          twitterLink
          location {
            __typename
            ... on LocationPublishedContent {
              country {
                __typename
                ... on FilePublishedMedia {
                  _url
                }
              }
            }
          }
        }
      }
      _children {
        items {
          __typename
          ... on EventDayPublishedContent {
            _id
            _url
            title
            date
            endDayTime
            endDayText
            _children {
              items {
                __typename
                ... on BreakLinePublishedContent {
                  title
                  text
                  startTime
                  duration
                  isBreakLine
                  language
                  background
                }
                ... on SpeechPublishedContent {
                  _id
                  duration
                  language
                  startTime
                  text
                  title
                  track
                  type
                  speakers {
                    __typename
                    ... on SpeakerPublishedContent {
                      speakerName
                      speakerPreviewDescription
                      _url
                      speakerImage
                      facebookLink
                      linkedinLink
                      twitterLink
                      location {
                        __typename
                        ... on LocationPublishedContent {
                          country {
                            __typename
                            ... on FilePublishedMedia {
                              _url
                            }
                          }
                        }
                      }
                    }
                  }
                  _parent {
                    __typename
                    ... on EventDayPublishedContent {
                      _id
                      title
                      date
                      endDayTime
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

fragment BecomePartnerQuery on HomePublishedContent {
  _children {
    items {
      __typename
      ... on FormPagePublishedContent {
        title
        metaTitle
        formType
        content
        nameLabel
        surnameLabel
        emailLabel
        companyNameLabel
        privacyPolicyLabelText
        partnerAdditionalInfoLabel
        submitButtonLabel
        partnerAdditionalInfoPlaceholder
      }
    }
  }
}

fragment BecomeSpeakerQuery on HomePublishedContent {
  _children {
    items {
      __typename
      ... on FormPagePublishedContent {
        title
        metaTitle
        formType
        content
        nameLabel
        surnameLabel
        emailLabel
        companyNameLabel
        registrationCityLabel
        privacyPolicyLabelText
        speakerTitleLabel
        speakerBioLabel
        speakerSocialMediaLabel
        speakerPhotoLabel
        speakerTalkTitle
        speakerTalkNameLabel
        speakerFormatLabel
        speakerFormatTooltip
        speakerLanguageLabel
        speakerTrackLabel
        speakerTrackTooltip
        speakerAudienceLevelLabel
        speakerTalkKeyPointsLabel
        speakerTalkDescriptionLabel
        speakerCoSpeakerLabel
        speakerCodeOfConductAndSpeakerContractAgreementLabel
        speakerAddTalkButtonLabel
        submitButtonLabel
        cityPlaceholder
        speakerBioPlaceholder
        speakerFacebookLinkPlaceholder
        speakerLinkedinLinkPlaceholder
        speakerTwitterLinkPlaceholder
        speakerPhotoPlaceholder
        speakerPhotoBottomDescription
        speakerFormatPlaceholder
        speakerLanguagePlaceholder
        speakerTrackPlaceholder
        speakerAudienceLevelPlaceholder
        speakerTalkKeyPointsPlaceholder
        speakerTalkDescriptionPlaceholder
        speakerFormatValues
        speakerLanguageValues
        speakerTrackValues
        speakerAudienceLevelValues
        speakerBioTooltip
        speakerTalkNameTooltip
        speakerTalkDescriptionTooltip
        speakerLanguageTooltip
      }
    }
  }
}

fragment CodeOfConductQuery on HomePublishedContent {
  _children {
    items {
      __typename
      ... on AboutPublishedContent {
        _children {
          items {
            __typename
            ... on ContentPagePublishedContent {
              __isContentPagePublishedContent: __typename
              metaTitle
              title
              content
              ... on SimplePagePublishedContent {
                pageName
              }
            }
          }
        }
      }
    }
  }
}

fragment Donate on HomePublishedContent {
  bottomSectionTitle
  bottomSectionSubtitle
  bottomSectionText
  bottomSectionSidePicture
  bottomSectionHide
  donateUrl
}

fragment FaqQuery on HomePublishedContent {
  _children {
    items {
      __typename
      ... on FAQPagePublishedContent {
        _name
        metaTitle
        title
        content
        contentPicture {
          __typename
          _name
          _url
        }
        _children {
          items {
            __typename
            ... on FaqItemPublishedContent {
              question
              answer
              scrollID
              _url
            }
          }
        }
      }
    }
  }
}

fragment HeroBanner on HomePublishedContent {
  bannerContent
  bannerDate
  bannerMessages
}

fragment Home_query on HomePublishedContent {
  metaTitle
  stopLookingForSpeakers
  becomeAPartner
  hideTopics
  ...HeroBanner
  ...SiteDescription
  ...Partners
  ...Donate
}

fragment Home_query_partners on PublishedContentByTypeQuery {
  partners {
    items {
      _children(orderBy: _updateDate_DESC) {
        items {
          __typename
          ... on PartnerPublishedContent {
            partnerSiteUrl
            picture
            _name
            _id
          }
        }
      }
    }
  }
}

fragment Home_query_speakers on PublishedContentByTypeQuery {
  speakers {
    items {
      _children {
        items {
          __typename
          ... on SpeakerPublishedContent {
            _id
            _url
            _name
            speakerName
            speakerPreviewDescription
            speakerImage
            location {
              __typename
              ... on LocationPublishedContent {
                city
                countryName
                country {
                  __typename
                  ... on FilePublishedMedia {
                    _url
                  }
                }
              }
            }
            facebookLink
            twitterLink
            linkedinLink
          }
        }
      }
    }
  }
}

fragment NotFound on ErrorPagePublishedContentConnection {
  items {
    title
    subtitle
    text
    errorCode
    button {
      name
      url
      target
    }
  }
}

fragment Partners on HomePublishedContent {
  partners {
    __typename
    ... on PartnerPublishedContent {
      partnerSiteUrl
      picture
      _name
      _id
    }
  }
}

fragment PartnersPageQuery on PublishedContentByTypeQuery {
  partners {
    items {
      bottomTitle
      bottomText
      file
      fileTitle
      fileSize
      fileLastUpdateDate
      bottomText2
      _children(orderBy: _updateDate_DESC) {
        items {
          __typename
          ... on PartnerPublishedContent {
            _id
            _name
            _createDate
            partnerSiteUrl
            picture
            section {
              __typename
              ... on PartnerSectionPublishedContent {
                _id
                title
              }
            }
          }
        }
      }
      sections {
        __typename
        ... on PartnerSectionPublishedContent {
          _id
          title
          _umbDocumentParents(orderBy: _createDate_DESC) {
            items {
              __typename
              ... on PartnerPublishedContent {
                _name
                _createDate
                partnerSiteUrl
                picture
              }
            }
          }
        }
      }
    }
  }
}

fragment PolicyQuery on HomePublishedContent {
  _children {
    items {
      __typename
      ... on AboutPublishedContent {
        _children {
          items {
            __typename
            ... on ContentPagePublishedContent {
              __isContentPagePublishedContent: __typename
              metaTitle
              title
              content
              ... on SimplePagePublishedContent {
                pageName
              }
            }
          }
        }
      }
    }
  }
}

fragment RegisterForEventQuery on HomePublishedContent {
  _children {
    items {
      __typename
      ... on FormPagePublishedContent {
        title
        metaTitle
        formType
        content
        nameLabel
        surnameLabel
        emailLabel
        registrationCityLabel
        citySubfieldLabel
        privacyPolicyLabelText
        registrationSkillsLabel
        registrationLevelLabel
        registrationNewslettersAgreementLabel
        registrationPossibleCooperationAgreementLabel
        submitButtonLabel
        cityPlaceholder
        registrationLevelPlaceholder
        registrationSkillsValues
        registrationLevelValues
      }
    }
  }
}

fragment ReportAccidentQuery on HomePublishedContent {
  _children {
    items {
      __typename
      ... on FormPagePublishedContent {
        title
        metaTitle
        formType
        content
        accidentDetailsOfIncidentLabel
        submitButtonLabel
      }
    }
  }
}

fragment SiteDescription on HomePublishedContent {
  shortDescriptionTitle
  shortDescriptionContent
}

fragment SpeakerContractQuery on HomePublishedContent {
  _children {
    items {
      __typename
      ... on FormPagePublishedContent {
        _children {
          items {
            __typename
            ... on ContentPagePublishedContent {
              __isContentPagePublishedContent: __typename
              metaTitle
              title
              content
              ... on SimplePagePublishedContent {
                pageName
              }
            }
          }
        }
      }
    }
  }
}

fragment SpeakerPageQuery on PublishedContentByTypeQuery {
  speakers {
    items {
      _children {
        items {
          __typename
          ... on SpeakerPublishedContent {
            _id
            _url
            pageTitle
            bio
            speakerName
            speakerPreviewDescription
            speakerImage
            location {
              __typename
              ... on LocationPublishedContent {
                city
                countryName
                country {
                  __typename
                  ... on FilePublishedMedia {
                    _url
                  }
                }
              }
            }
            facebookLink
            twitterLink
            linkedinLink
          }
        }
      }
    }
  }
  speech {
    items {
      _id
      duration
      language
      startTime
      text
      title
      track
      type
      speakers {
        __typename
        ... on SpeakerPublishedContent {
          speakerName
          speakerImage
          speakerPreviewDescription
          _url
          location {
            __typename
            ... on LocationPublishedContent {
              country {
                __typename
                ... on FilePublishedMedia {
                  _url
                }
              }
            }
          }
        }
      }
      _parent {
        __typename
        ... on EventDayPublishedContent {
          _id
          title
          date
          endDayTime
        }
      }
    }
  }
}

fragment SpeakersPageQuery on PublishedContentByTypeQuery {
  home {
    items {
      stopLookingForSpeakers
    }
  }
  speakers {
    items {
      _children {
        items {
          __typename
          ... on SpeakerPublishedContent {
            _id
            _url
            speakerName
            speakerPreviewDescription
            speakerImage
            location {
              __typename
              ... on LocationPublishedContent {
                city
                countryName
                country {
                  __typename
                  ... on FilePublishedMedia {
                    _url
                  }
                }
              }
            }
            facebookLink
            twitterLink
            linkedinLink
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "StringStringKeyValuePair",
  "kind": "LinkedField",
  "name": "getAllDictionary",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "technologies",
      "storageKey": null
    }
  ],
  "type": "ThemesPublishedContent",
  "abstractKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "speakerName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "speakerPreviewDescription",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "speakerImage",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facebookLink",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitterLink",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkedinLink",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryName",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/)
  ],
  "type": "FilePublishedMedia",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stopLookingForSpeakers",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "country",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v13/*: any*/),
        (v14/*: any*/),
        (v18/*: any*/)
      ],
      "type": "LocationPublishedContent",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_createDate",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partnerSiteUrl",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTime",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "track",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v18/*: any*/)
      ],
      "type": "LocationPublishedContent",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDayTime",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "_parent",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v4/*: any*/),
        (v2/*: any*/),
        (v30/*: any*/),
        (v31/*: any*/)
      ],
      "type": "EventDayPublishedContent",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaTitle",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v35 = [
  (v17/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "PublishedContentConnection",
  "kind": "LinkedField",
  "name": "_children",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v17/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v33/*: any*/),
            (v2/*: any*/),
            (v34/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageName",
                  "storageKey": null
                }
              ],
              "type": "SimplePagePublishedContent",
              "abstractKey": null
            }
          ],
          "type": "ContentPagePublishedContent",
          "abstractKey": "__isContentPagePublishedContent"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UmbracoQuery",
        "kind": "LinkedField",
        "name": "umbraco",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PublishedContentQuery",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PublishedContentByTypeQuery",
                "kind": "LinkedField",
                "name": "byType",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SpeakersPageQuery"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PartnersPageQuery"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Home_query_speakers"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Home_query_partners"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SpeakerPageQuery"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AgendaPageQuery"
                  }
                ],
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PublishedContentAtRootQuery",
                "kind": "LinkedField",
                "name": "atRoot",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ErrorPagePublishedContentConnection",
                    "kind": "LinkedField",
                    "name": "errorPage",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "NotFound"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HomePublishedContentConnection",
                    "kind": "LinkedField",
                    "name": "home",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HomePublishedContent",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "themes",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "speaker",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v13/*: any*/),
                                          (v14/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "country",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "LocationPublishedContent",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "SpeakerPublishedContent",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "Home_query"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FaqQuery"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AboutQuery"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PolicyQuery"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "CodeOfConductQuery"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "BecomePartnerQuery"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "RegisterForEventQuery"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "BecomeSpeakerQuery"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "SpeakerContractQuery"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ReportAccidentQuery"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UmbracoQuery",
        "kind": "LinkedField",
        "name": "umbraco",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PublishedContentQuery",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PublishedContentByTypeQuery",
                "kind": "LinkedField",
                "name": "byType",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HomePublishedContentConnection",
                    "kind": "LinkedField",
                    "name": "home",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HomePublishedContent",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SpeakersPublishedContentConnection",
                    "kind": "LinkedField",
                    "name": "speakers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SpeakersPublishedContent",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PublishedContentConnection",
                            "kind": "LinkedField",
                            "name": "_children",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v4/*: any*/),
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v19/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "pageTitle",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bio",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "SpeakerPublishedContent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PartnersPublishedContentConnection",
                    "kind": "LinkedField",
                    "name": "partners",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartnersPublishedContent",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bottomTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bottomText",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "file",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fileTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fileSize",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fileLastUpdateDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bottomText2",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "orderBy",
                                "value": "_updateDate_DESC"
                              }
                            ],
                            "concreteType": "PublishedContentConnection",
                            "kind": "LinkedField",
                            "name": "_children",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      (v20/*: any*/),
                                      (v21/*: any*/),
                                      (v22/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "section",
                                        "plural": true,
                                        "selections": [
                                          (v17/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v4/*: any*/),
                                              (v2/*: any*/)
                                            ],
                                            "type": "PartnerSectionPublishedContent",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PartnerPublishedContent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "_children(orderBy:\"_updateDate_DESC\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "orderBy",
                                        "value": "_createDate_DESC"
                                      }
                                    ],
                                    "concreteType": "PublishedContentConnection",
                                    "kind": "LinkedField",
                                    "name": "_umbDocumentParents",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "items",
                                        "plural": true,
                                        "selections": [
                                          (v17/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v5/*: any*/),
                                              (v20/*: any*/),
                                              (v21/*: any*/),
                                              (v22/*: any*/)
                                            ],
                                            "type": "PartnerPublishedContent",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "_umbDocumentParents(orderBy:\"_createDate_DESC\")"
                                  }
                                ],
                                "type": "PartnerSectionPublishedContent",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SpeechPublishedContentConnection",
                    "kind": "LinkedField",
                    "name": "speech",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SpeechPublishedContent",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v2/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "speakers",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v9/*: any*/),
                                  (v8/*: any*/),
                                  (v6/*: any*/),
                                  (v29/*: any*/)
                                ],
                                "type": "SpeakerPublishedContent",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v32/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaPublishedContentConnection",
                    "kind": "LinkedField",
                    "name": "agenda",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgendaPublishedContent",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "programCommitee",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v9/*: any*/),
                                  (v8/*: any*/),
                                  (v10/*: any*/),
                                  (v12/*: any*/),
                                  (v11/*: any*/),
                                  (v29/*: any*/)
                                ],
                                "type": "SpeakerPublishedContent",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PublishedContentConnection",
                            "kind": "LinkedField",
                            "name": "_children",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v4/*: any*/),
                                      (v6/*: any*/),
                                      (v2/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "endDayText",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PublishedContentConnection",
                                        "kind": "LinkedField",
                                        "name": "_children",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                              (v17/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v26/*: any*/),
                                                  (v25/*: any*/),
                                                  (v23/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isBreakLine",
                                                    "storageKey": null
                                                  },
                                                  (v24/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "background",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "BreakLinePublishedContent",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v4/*: any*/),
                                                  (v23/*: any*/),
                                                  (v24/*: any*/),
                                                  (v25/*: any*/),
                                                  (v26/*: any*/),
                                                  (v2/*: any*/),
                                                  (v27/*: any*/),
                                                  (v28/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "speakers",
                                                    "plural": true,
                                                    "selections": [
                                                      (v17/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v7/*: any*/),
                                                          (v8/*: any*/),
                                                          (v6/*: any*/),
                                                          (v9/*: any*/),
                                                          (v10/*: any*/),
                                                          (v12/*: any*/),
                                                          (v11/*: any*/),
                                                          (v29/*: any*/)
                                                        ],
                                                        "type": "SpeakerPublishedContent",
                                                        "abstractKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v32/*: any*/)
                                                ],
                                                "type": "SpeechPublishedContent",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "EventDayPublishedContent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PublishedContentAtRootQuery",
                "kind": "LinkedField",
                "name": "atRoot",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ErrorPagePublishedContentConnection",
                    "kind": "LinkedField",
                    "name": "errorPage",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ErrorPagePublishedContent",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subtitle",
                            "storageKey": null
                          },
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "errorCode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Link",
                            "kind": "LinkedField",
                            "name": "button",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "target",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HomePublishedContentConnection",
                    "kind": "LinkedField",
                    "name": "home",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HomePublishedContent",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v33/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "becomeAPartner",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hideTopics",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bannerContent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bannerDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bannerMessages",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shortDescriptionTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shortDescriptionContent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "partners",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v5/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "type": "PartnerPublishedContent",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bottomSectionTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bottomSectionSubtitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bottomSectionText",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bottomSectionSidePicture",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bottomSectionHide",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "donateUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PublishedContentConnection",
                            "kind": "LinkedField",
                            "name": "_children",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v5/*: any*/),
                                      (v33/*: any*/),
                                      (v2/*: any*/),
                                      (v34/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "contentPicture",
                                        "plural": false,
                                        "selections": (v35/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PublishedContentConnection",
                                        "kind": "LinkedField",
                                        "name": "_children",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                              (v17/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "question",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "answer",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "scrollID",
                                                    "storageKey": null
                                                  },
                                                  (v6/*: any*/)
                                                ],
                                                "type": "FaqItemPublishedContent",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "FAQPagePublishedContent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "brandPacks",
                                        "plural": true,
                                        "selections": [
                                          (v17/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "brandTitle",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "darkMode",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "logoPreview",
                                                "plural": false,
                                                "selections": [
                                                  (v17/*: any*/),
                                                  (v6/*: any*/),
                                                  (v5/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "sVGResource",
                                                "plural": false,
                                                "selections": (v35/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "pNGResource",
                                                "plural": false,
                                                "selections": (v35/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "ePSResource",
                                                "plural": false,
                                                "selections": (v35/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "BrandPackPublishedContent",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v33/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "headerTilte",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "headerText",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "photoCarousel",
                                        "plural": true,
                                        "selections": [
                                          (v17/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v22/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "fullImage",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CarouselItemPicturePublishedContent",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "infoItems",
                                        "plural": true,
                                        "selections": [
                                          (v17/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v26/*: any*/),
                                              (v0/*: any*/)
                                            ],
                                            "type": "InfoItemPublishedContent",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "contentText",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "contentTitle",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "conferenceFiles",
                                        "plural": true,
                                        "selections": [
                                          (v17/*: any*/),
                                          (v4/*: any*/),
                                          (v5/*: any*/),
                                          (v6/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "umbracoBytes",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "_updateDate",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "FilePublishedMedia",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v36/*: any*/)
                                    ],
                                    "type": "AboutPublishedContent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v2/*: any*/),
                                      (v33/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "formType",
                                        "storageKey": null
                                      },
                                      (v34/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "nameLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "surnameLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "emailLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "companyNameLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "privacyPolicyLabelText",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "partnerAdditionalInfoLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "submitButtonLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "partnerAdditionalInfoPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "registrationCityLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "citySubfieldLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "registrationSkillsLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "registrationLevelLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "registrationNewslettersAgreementLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "registrationPossibleCooperationAgreementLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "cityPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "registrationLevelPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "registrationSkillsValues",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "registrationLevelValues",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTitleLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerBioLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerSocialMediaLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerPhotoLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTalkTitle",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTalkNameLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerFormatLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerFormatTooltip",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerLanguageLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTrackLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTrackTooltip",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerAudienceLevelLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTalkKeyPointsLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTalkDescriptionLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerCoSpeakerLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerCodeOfConductAndSpeakerContractAgreementLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerAddTalkButtonLabel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerBioPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerFacebookLinkPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerLinkedinLinkPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTwitterLinkPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerPhotoPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerPhotoBottomDescription",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerFormatPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerLanguagePlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTrackPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerAudienceLevelPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTalkKeyPointsPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTalkDescriptionPlaceholder",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerFormatValues",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerLanguageValues",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTrackValues",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerAudienceLevelValues",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerBioTooltip",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTalkNameTooltip",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerTalkDescriptionTooltip",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "speakerLanguageTooltip",
                                        "storageKey": null
                                      },
                                      (v36/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "accidentDetailsOfIncidentLabel",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "FormPagePublishedContent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "themes",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "speaker",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v19/*: any*/)
                                ],
                                "type": "SpeakerPublishedContent",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "54f0a20377a69cb31ef81b023921d09c",
    "id": null,
    "metadata": {},
    "name": "AppQuery",
    "operationKind": "query",
    "text": "query AppQuery {\n  umbraco {\n    content {\n      byType {\n        ...SpeakersPageQuery\n        ...PartnersPageQuery\n        ...Home_query_speakers\n        ...Home_query_partners\n        ...SpeakerPageQuery\n        ...AgendaPageQuery\n      }\n      getAllDictionary {\n        key\n        value\n      }\n      atRoot {\n        errorPage {\n          ...NotFound\n        }\n        home {\n          items {\n            ...Home_query\n            ...FaqQuery\n            ...AboutQuery\n            ...PolicyQuery\n            ...CodeOfConductQuery\n            ...BecomePartnerQuery\n            ...RegisterForEventQuery\n            ...BecomeSpeakerQuery\n            ...SpeakerContractQuery\n            ...ReportAccidentQuery\n            themes {\n              __typename\n              ... on ThemesPublishedContent {\n                title\n                technologies\n              }\n            }\n            speaker {\n              __typename\n              ... on SpeakerPublishedContent {\n                _id\n                _name\n                _url\n                speakerName\n                speakerPreviewDescription\n                speakerImage\n                facebookLink\n                twitterLink\n                linkedinLink\n                location {\n                  __typename\n                  ... on LocationPublishedContent {\n                    city\n                    countryName\n                    country {\n                      __typename\n                      ... on FilePublishedMedia {\n                        _url\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AboutQuery on HomePublishedContent {\n  _children {\n    items {\n      __typename\n      ... on AboutPublishedContent {\n        brandPacks {\n          __typename\n          ... on BrandPackPublishedContent {\n            brandTitle\n            darkMode\n            logoPreview {\n              __typename\n              _url\n              _name\n            }\n            sVGResource {\n              __typename\n              _name\n              _url\n            }\n            pNGResource {\n              __typename\n              _name\n              _url\n            }\n            ePSResource {\n              __typename\n              _name\n              _url\n            }\n          }\n        }\n        metaTitle\n        headerTilte\n        headerText\n        photoCarousel {\n          __typename\n          ... on CarouselItemPicturePublishedContent {\n            picture\n            fullImage\n          }\n        }\n        infoItems {\n          __typename\n          ... on InfoItemPublishedContent {\n            text\n            value\n          }\n        }\n        contentText\n        contentTitle\n        conferenceFiles {\n          __typename\n          _id\n          _name\n          _url\n          ... on FilePublishedMedia {\n            umbracoBytes\n            _updateDate\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AgendaPageQuery on PublishedContentByTypeQuery {\n  agenda {\n    items {\n      programCommitee {\n        __typename\n        ... on SpeakerPublishedContent {\n          _id\n          _url\n          speakerName\n          speakerImage\n          speakerPreviewDescription\n          facebookLink\n          linkedinLink\n          twitterLink\n          location {\n            __typename\n            ... on LocationPublishedContent {\n              country {\n                __typename\n                ... on FilePublishedMedia {\n                  _url\n                }\n              }\n            }\n          }\n        }\n      }\n      _children {\n        items {\n          __typename\n          ... on EventDayPublishedContent {\n            _id\n            _url\n            title\n            date\n            endDayTime\n            endDayText\n            _children {\n              items {\n                __typename\n                ... on BreakLinePublishedContent {\n                  title\n                  text\n                  startTime\n                  duration\n                  isBreakLine\n                  language\n                  background\n                }\n                ... on SpeechPublishedContent {\n                  _id\n                  duration\n                  language\n                  startTime\n                  text\n                  title\n                  track\n                  type\n                  speakers {\n                    __typename\n                    ... on SpeakerPublishedContent {\n                      speakerName\n                      speakerPreviewDescription\n                      _url\n                      speakerImage\n                      facebookLink\n                      linkedinLink\n                      twitterLink\n                      location {\n                        __typename\n                        ... on LocationPublishedContent {\n                          country {\n                            __typename\n                            ... on FilePublishedMedia {\n                              _url\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                  _parent {\n                    __typename\n                    ... on EventDayPublishedContent {\n                      _id\n                      title\n                      date\n                      endDayTime\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment BecomePartnerQuery on HomePublishedContent {\n  _children {\n    items {\n      __typename\n      ... on FormPagePublishedContent {\n        title\n        metaTitle\n        formType\n        content\n        nameLabel\n        surnameLabel\n        emailLabel\n        companyNameLabel\n        privacyPolicyLabelText\n        partnerAdditionalInfoLabel\n        submitButtonLabel\n        partnerAdditionalInfoPlaceholder\n      }\n    }\n  }\n}\n\nfragment BecomeSpeakerQuery on HomePublishedContent {\n  _children {\n    items {\n      __typename\n      ... on FormPagePublishedContent {\n        title\n        metaTitle\n        formType\n        content\n        nameLabel\n        surnameLabel\n        emailLabel\n        companyNameLabel\n        registrationCityLabel\n        privacyPolicyLabelText\n        speakerTitleLabel\n        speakerBioLabel\n        speakerSocialMediaLabel\n        speakerPhotoLabel\n        speakerTalkTitle\n        speakerTalkNameLabel\n        speakerFormatLabel\n        speakerFormatTooltip\n        speakerLanguageLabel\n        speakerTrackLabel\n        speakerTrackTooltip\n        speakerAudienceLevelLabel\n        speakerTalkKeyPointsLabel\n        speakerTalkDescriptionLabel\n        speakerCoSpeakerLabel\n        speakerCodeOfConductAndSpeakerContractAgreementLabel\n        speakerAddTalkButtonLabel\n        submitButtonLabel\n        cityPlaceholder\n        speakerBioPlaceholder\n        speakerFacebookLinkPlaceholder\n        speakerLinkedinLinkPlaceholder\n        speakerTwitterLinkPlaceholder\n        speakerPhotoPlaceholder\n        speakerPhotoBottomDescription\n        speakerFormatPlaceholder\n        speakerLanguagePlaceholder\n        speakerTrackPlaceholder\n        speakerAudienceLevelPlaceholder\n        speakerTalkKeyPointsPlaceholder\n        speakerTalkDescriptionPlaceholder\n        speakerFormatValues\n        speakerLanguageValues\n        speakerTrackValues\n        speakerAudienceLevelValues\n        speakerBioTooltip\n        speakerTalkNameTooltip\n        speakerTalkDescriptionTooltip\n        speakerLanguageTooltip\n      }\n    }\n  }\n}\n\nfragment CodeOfConductQuery on HomePublishedContent {\n  _children {\n    items {\n      __typename\n      ... on AboutPublishedContent {\n        _children {\n          items {\n            __typename\n            ... on ContentPagePublishedContent {\n              __isContentPagePublishedContent: __typename\n              metaTitle\n              title\n              content\n              ... on SimplePagePublishedContent {\n                pageName\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment Donate on HomePublishedContent {\n  bottomSectionTitle\n  bottomSectionSubtitle\n  bottomSectionText\n  bottomSectionSidePicture\n  bottomSectionHide\n  donateUrl\n}\n\nfragment FaqQuery on HomePublishedContent {\n  _children {\n    items {\n      __typename\n      ... on FAQPagePublishedContent {\n        _name\n        metaTitle\n        title\n        content\n        contentPicture {\n          __typename\n          _name\n          _url\n        }\n        _children {\n          items {\n            __typename\n            ... on FaqItemPublishedContent {\n              question\n              answer\n              scrollID\n              _url\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment HeroBanner on HomePublishedContent {\n  bannerContent\n  bannerDate\n  bannerMessages\n}\n\nfragment Home_query on HomePublishedContent {\n  metaTitle\n  stopLookingForSpeakers\n  becomeAPartner\n  hideTopics\n  ...HeroBanner\n  ...SiteDescription\n  ...Partners\n  ...Donate\n}\n\nfragment Home_query_partners on PublishedContentByTypeQuery {\n  partners {\n    items {\n      _children(orderBy: _updateDate_DESC) {\n        items {\n          __typename\n          ... on PartnerPublishedContent {\n            partnerSiteUrl\n            picture\n            _name\n            _id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment Home_query_speakers on PublishedContentByTypeQuery {\n  speakers {\n    items {\n      _children {\n        items {\n          __typename\n          ... on SpeakerPublishedContent {\n            _id\n            _url\n            _name\n            speakerName\n            speakerPreviewDescription\n            speakerImage\n            location {\n              __typename\n              ... on LocationPublishedContent {\n                city\n                countryName\n                country {\n                  __typename\n                  ... on FilePublishedMedia {\n                    _url\n                  }\n                }\n              }\n            }\n            facebookLink\n            twitterLink\n            linkedinLink\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NotFound on ErrorPagePublishedContentConnection {\n  items {\n    title\n    subtitle\n    text\n    errorCode\n    button {\n      name\n      url\n      target\n    }\n  }\n}\n\nfragment Partners on HomePublishedContent {\n  partners {\n    __typename\n    ... on PartnerPublishedContent {\n      partnerSiteUrl\n      picture\n      _name\n      _id\n    }\n  }\n}\n\nfragment PartnersPageQuery on PublishedContentByTypeQuery {\n  partners {\n    items {\n      bottomTitle\n      bottomText\n      file\n      fileTitle\n      fileSize\n      fileLastUpdateDate\n      bottomText2\n      _children(orderBy: _updateDate_DESC) {\n        items {\n          __typename\n          ... on PartnerPublishedContent {\n            _id\n            _name\n            _createDate\n            partnerSiteUrl\n            picture\n            section {\n              __typename\n              ... on PartnerSectionPublishedContent {\n                _id\n                title\n              }\n            }\n          }\n        }\n      }\n      sections {\n        __typename\n        ... on PartnerSectionPublishedContent {\n          _id\n          title\n          _umbDocumentParents(orderBy: _createDate_DESC) {\n            items {\n              __typename\n              ... on PartnerPublishedContent {\n                _name\n                _createDate\n                partnerSiteUrl\n                picture\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment PolicyQuery on HomePublishedContent {\n  _children {\n    items {\n      __typename\n      ... on AboutPublishedContent {\n        _children {\n          items {\n            __typename\n            ... on ContentPagePublishedContent {\n              __isContentPagePublishedContent: __typename\n              metaTitle\n              title\n              content\n              ... on SimplePagePublishedContent {\n                pageName\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment RegisterForEventQuery on HomePublishedContent {\n  _children {\n    items {\n      __typename\n      ... on FormPagePublishedContent {\n        title\n        metaTitle\n        formType\n        content\n        nameLabel\n        surnameLabel\n        emailLabel\n        registrationCityLabel\n        citySubfieldLabel\n        privacyPolicyLabelText\n        registrationSkillsLabel\n        registrationLevelLabel\n        registrationNewslettersAgreementLabel\n        registrationPossibleCooperationAgreementLabel\n        submitButtonLabel\n        cityPlaceholder\n        registrationLevelPlaceholder\n        registrationSkillsValues\n        registrationLevelValues\n      }\n    }\n  }\n}\n\nfragment ReportAccidentQuery on HomePublishedContent {\n  _children {\n    items {\n      __typename\n      ... on FormPagePublishedContent {\n        title\n        metaTitle\n        formType\n        content\n        accidentDetailsOfIncidentLabel\n        submitButtonLabel\n      }\n    }\n  }\n}\n\nfragment SiteDescription on HomePublishedContent {\n  shortDescriptionTitle\n  shortDescriptionContent\n}\n\nfragment SpeakerContractQuery on HomePublishedContent {\n  _children {\n    items {\n      __typename\n      ... on FormPagePublishedContent {\n        _children {\n          items {\n            __typename\n            ... on ContentPagePublishedContent {\n              __isContentPagePublishedContent: __typename\n              metaTitle\n              title\n              content\n              ... on SimplePagePublishedContent {\n                pageName\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment SpeakerPageQuery on PublishedContentByTypeQuery {\n  speakers {\n    items {\n      _children {\n        items {\n          __typename\n          ... on SpeakerPublishedContent {\n            _id\n            _url\n            pageTitle\n            bio\n            speakerName\n            speakerPreviewDescription\n            speakerImage\n            location {\n              __typename\n              ... on LocationPublishedContent {\n                city\n                countryName\n                country {\n                  __typename\n                  ... on FilePublishedMedia {\n                    _url\n                  }\n                }\n              }\n            }\n            facebookLink\n            twitterLink\n            linkedinLink\n          }\n        }\n      }\n    }\n  }\n  speech {\n    items {\n      _id\n      duration\n      language\n      startTime\n      text\n      title\n      track\n      type\n      speakers {\n        __typename\n        ... on SpeakerPublishedContent {\n          speakerName\n          speakerImage\n          speakerPreviewDescription\n          _url\n          location {\n            __typename\n            ... on LocationPublishedContent {\n              country {\n                __typename\n                ... on FilePublishedMedia {\n                  _url\n                }\n              }\n            }\n          }\n        }\n      }\n      _parent {\n        __typename\n        ... on EventDayPublishedContent {\n          _id\n          title\n          date\n          endDayTime\n        }\n      }\n    }\n  }\n}\n\nfragment SpeakersPageQuery on PublishedContentByTypeQuery {\n  home {\n    items {\n      stopLookingForSpeakers\n    }\n  }\n  speakers {\n    items {\n      _children {\n        items {\n          __typename\n          ... on SpeakerPublishedContent {\n            _id\n            _url\n            speakerName\n            speakerPreviewDescription\n            speakerImage\n            location {\n              __typename\n              ... on LocationPublishedContent {\n                city\n                countryName\n                country {\n                  __typename\n                  ... on FilePublishedMedia {\n                    _url\n                  }\n                }\n              }\n            }\n            facebookLink\n            twitterLink\n            linkedinLink\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b2fe4e2ab3163d6b2ec5fdafbfa8252a';
export default node;
